// src/widget.jsx
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import SystemMap from "./pages/SystemMap.jsx";

import "./assets/styles/styles.scss";

function mount() {
  const el = document.getElementById("ict-routes-application-map-block");
  if (!el || el.__reactRoot) return;

  el.__reactRoot = ReactDOM.createRoot(el);
  el.__reactRoot.render(
    <BrowserRouter>
      <SystemMap />
    </BrowserRouter>
  );

}

/* run immediately */
mount();

/* run again after Drupal AJAX attaches */
document.addEventListener("DOMContentLoaded", mount);
